import { Registry, Utils } from "@lightningjs/sdk";
import Lightning from "@lightningjs/sdk/src/Lightning";
import { Icon } from "@lightningjs/ui-components";
import { Helper } from "../../lib/helper";

export interface NoficationBoxTemplateSpec extends Lightning.Component.TemplateSpecLoose {

}

export default class NoficationBox
  extends Lightning.Component
  implements Lightning.Component<NoficationBoxTemplateSpec>
{
  _index: number = -1
  _messageType: string = 'success' // success, warn, error
  enterAnimation!: any
  exitAnimation!: any

  static override _template(): Lightning.Component.Template<NoficationBoxTemplateSpec> {
    return {
      rect: true,
      color: 0xffff0000,
      flexItem: { margin: 20 },
      Label: {
        text: { paddingLeft: 20, paddingRight: 20, text: this.bindProp('msg'), fontFace: Helper.getFontFamily('Regular'), fontSize: 30 }
      }
    }
  }

  set messageType(value: string) {
    this._messageType = value
  }

  _getBgColor(type: string): any {
    if (type == 'error') {
      return 0xAAF13637
    } else if (type == 'warn') {
      return 0xAAF13637
    }
    return 0x88209F22
  }

  override _init() {
    //Log.info('Notification Box _init')
    this.tag('Label').on('txLoaded', () => {
      this.patch({
        w: this.tag('Label').renderWidth,
        h: this.tag('Label').renderHeight,
        color: this._getBgColor(this._messageType)
      })
    })
    this.enterAnimation = this.animation({
      duration: 0.25,
      stopMethod: 'immediate',
      actions: [
        { p: 'alpha', v: { 0: 0.001, 1: 1 } },
      ]
    })

    this.exitAnimation = this.animation({
      duration: 0.25,
      stopMethod: 'immediate',
      actions: [
        { p: 'alpha', v: { 0: 1, 1: 0.001 } },
      ]
    })

    this.enterAnimation.on('finish', () => {
      Registry.setTimeout(() => {
        this.exitAnimation.start()
      }, 3000)
    })

    this.exitAnimation.on('finish', () => {
      this.getAncestor(1)?.childList.remove(this)
    })

    this.enterAnimation.start()
  }
}
